import { CaseServiceModel } from './case-service.model';

export class EditCaseServiceModel extends CaseServiceModel{

}
